import React, { useContext, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import { AuthContext } from "../context/AuthContext";

const StudentLayout = () => {
  const { user } = useContext(AuthContext);

  // Navbar (mobile navbar menu)
  const [isNavOpen, setIsNavOpen] = useState(false);

  // Sidebar
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileOpen(false);
        setIsNavOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Navbar */}
      <Navbar isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen} />

      {/* Mobile Sidebar Header (BELOW navbar) */}
      <div className="md:hidden fixed top-16 left-0 right-0 z-40 flex items-center gap-3 px-4 py-3 bg-white border-b shadow-sm">
        <button
          onClick={() => setIsMobileOpen(true)}
          className="p-2 rounded-md bg-blue-700 text-white hover:bg-blue-800 transition"
          aria-label="Open sidebar"
        >
          ☰
        </button>
        <span className="font-semibold text-gray-800">Student Portal</span>
      </div>

      <div className="flex pt-[7rem] md:pt-16 relative">
        {/* Sidebar */}
        <Sidebar
          role={user?.role}
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setIsSidebarCollapsed}
          isMobileOpen={isMobileOpen}
          setIsMobileOpen={setIsMobileOpen}
        />

        {/* Overlay */}
        {isMobileOpen && (
          <div
            className="fixed inset-0 bg-black/30 z-30 md:hidden"
            onClick={() => setIsMobileOpen(false)}
          />
        )}

        {/* Main content */}
        <main
          className= "flex-1 transition-all duration-300"
        >
          <div className="p-4 md:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default StudentLayout;